import { ReactComponent as EyeIcon } from './svg/eye.svg'

export default EyeIcon
